import { _ as _arrayFilter } from "./auth-service-tools1293.js";
import { s as stubArray_1 } from "./auth-service-tools1294.js";
var arrayFilter = _arrayFilter,
    stubArray = stubArray_1;
var objectProto = Object.prototype;
var propertyIsEnumerable = objectProto.propertyIsEnumerable;
var nativeGetSymbols = Object.getOwnPropertySymbols;
var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
  if (object == null) {
    return [];
  }

  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function (symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};
var _getSymbols = getSymbols;
export { _getSymbols as _ };